import { layout } from '../../../styled-system/recipes';
import { Unauthorized } from '../../components/Error/Unauthorized';
import { getErrorDescriptionParam } from '../../utils/auth/search-params';

const { errorContainer } = layout();
export function UnauthorizedPage() {
  const error = getErrorDescriptionParam();

  return (
    <div className={errorContainer}>
      <Unauthorized logout error={error} />
    </div>
  );
}
